// extracted by mini-css-extract-plugin
export var documentation = "_io-1";
export var menu = "_io-0";